import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import {Observable} from "rxjs/Rx";

import { environment } from '../../../environments/environment';

const url = 'https://maps.googleapis.com/maps/api/js?key=' + environment.GOOGLE_API_KEY + '&callback=__onGoogleLoaded';

@Injectable({
  providedIn: 'root'
})
export class GoogleApiService {

  public loadAPI:Promise<any>;

  constructor(private http: HttpClient) {
    if (window['google']) {
      this.loadAPI = Promise.resolve(window['google'])
    } else {
      this.loadAPI = new Promise((resolve) => {
        window['__onGoogleLoaded'] = (ev) => {
          resolve(window['google']);
        };
        this.loadScript()
      })
    }
  }

  loadScript() {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  public getLatLon(address): Observable<any> {
		//let headers = new Headers({'Access-Control-Allow-Headers': 'Content-Type, x-xsrf-token, Origin, X-Requested-With, Accept, Authorization'});
		let headers = new HttpHeaders();
		let options = { headers: headers };
		var geourl = "https://maps.googleapis.com/maps/api/geocode/json?address=" + address + "&key=" + environment.GOOGLE_API_KEY;
		return this.http.get(geourl, options)
      .map(this.extractData)
  }

  private extractData(body) {
    if (body) {
      return body.data || body
    } else {
      return {}
    }
  }

}
